
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","height":"34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"34","height":"34","rx":"3","fill":"#48AC98"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.735 10.049h6.529V9h-6.53v1.049zm18.384 9.297c-.956 0-1.618-.878-1.733-2.042.29-.993.934-1.488 1.696-1.488.979 0 1.53.722 1.53 1.748 0 1.1-.628 1.782-1.493 1.782zm.24-4.492c-.966 0-1.657.446-2.005 1.107 0-1.56.545-2.92 1.839-2.92.823 0 1.15.472 1.324 1.248l1.198-.24c-.282-1.338-1.133-1.989-2.514-1.989-1.734 0-3.031 1.33-3.031 4.31 0 2.646 1.081 3.954 2.946 3.954 1.54 0 2.694-1.05 2.694-2.782 0-1.352-.722-2.688-2.452-2.688zm-13.32-2.708v5.536c0 .49.011.786.034 1.071h-.023a6.355 6.355 0 00-.472-.984L8.3 12.146H6.8v8.092H7.97v-5.536c0-.49-.01-.786-.034-1.071h.023c.12.326.261.612.472.984l3.279 5.623h1.483v-8.092H12.04zm1.225 11.232h-6.53v-1.043h6.53v1.043zm5.48-5.696c-.389.387-1.263 1.087-1.873 1.508h3.66v1.048h-5.387v-.957c.625-.445 1.921-1.412 2.732-2.223.777-.776 1.286-1.484 1.286-2.524 0-1.024-.563-1.45-1.324-1.45-.78 0-1.403.45-1.403 1.39 0 .206.023.434.08.696l-1.224-.118a2.574 2.574 0 01-.08-.639c0-1.255.881-2.353 2.667-2.353 1.473 0 2.562.764 2.562 2.433 0 1.519-1.11 2.61-1.609 3.102l-.087.087z","fill":"#fff"}})])
          )
        }
      }
    